import { Typography, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { Cryptocurrency } from '../../../types/currency'
import { Feature, PaymentMethod, Platform } from '../../../types/wallet'
import Attribute from './Attribute'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      marginTop: '20px',
      width: '100%',
      flexDirection: 'row',
    },
  },
  attributesContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      flexDirection: 'column',
      width: '50%',
      justifyContent: 'flex-start',
    },
  },
  attributes: {
    marginTop: '5px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  subtitle: {},
  attributesSubcontainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

interface Props {
  paymentmethods?: PaymentMethod[]
  features?: Feature[]
  cryptocurrencies?: Cryptocurrency[]
  platforms?: Platform[]
  kyc_required?: boolean
  cash_trades?: boolean
  annual_fee?: string
  rewards?: string
}

function AttributesList({
  platforms,
  paymentmethods,
  cryptocurrencies,
  kyc_required,
  cash_trades,
  annual_fee,
  rewards,
}: Props): JSX.Element {
  const classes = useStyles({})

  return (
    <div className={classes.root}>
      {platforms && platforms.length ? (
        <div className={classes.attributesContainer}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            PLATFORMS
          </Typography>
          <div className={classes.attributesSubcontainer}>
            <div className={classes.attributes}>
              {platforms.slice(0, 4).map((platform, index) => (
                <Attribute {...platform} key={index} />
              ))}
            </div>
            {platforms.length > 4 ? (
              <Typography variant="subtitle1" className={classes.subtitle}>
                +{platforms.length - 4} more
              </Typography>
            ) : null}
          </div>
        </div>
      ) : null}
      {paymentmethods && paymentmethods?.length ? (
        <div className={classes.attributesContainer}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            PAYMENT
          </Typography>
          <div className={classes.attributesSubcontainer}>
            <div className={classes.attributes}>
              {paymentmethods.slice(0, 4).map((pm, index) => (
                <Attribute {...pm} key={index} />
              ))}
            </div>
            {paymentmethods.length > 4 ? (
              <Typography variant="subtitle1" className={classes.subtitle}>
                +{paymentmethods.length - 4} more
              </Typography>
            ) : null}
          </div>
        </div>
      ) : null}
      {cryptocurrencies && cryptocurrencies.length ? (
        <div className={classes.attributesContainer}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            ASSETS
          </Typography>
          <div className={classes.attributesSubcontainer}>
            <div className={classes.attributes}>
              {cryptocurrencies.slice(0, 4).map((currency) => (
                <Attribute {...currency} key={currency.code} />
              ))}
            </div>
            {cryptocurrencies.length > 4 ? (
              <Typography variant="subtitle1" className={classes.subtitle}>
                +{cryptocurrencies.length - 4} more
              </Typography>
            ) : null}
          </div>
        </div>
      ) : null}
      {kyc_required ? (
        <div className={classes.attributesContainer}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            KYC REQUIRED
          </Typography>
          <Typography variant="body1">{kyc_required ? 'Yes' : 'No'}</Typography>
        </div>
      ) : null}
      {cash_trades ? (
        <div className={classes.attributesContainer}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            CASH TRADES
          </Typography>
          <Typography variant="body1">{cash_trades ? 'Yes' : 'No'}</Typography>
        </div>
      ) : null}
      {annual_fee ? (
        <div className={classes.attributesContainer}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            ANNUAL FEE
          </Typography>
          <Typography variant="body1">{annual_fee}</Typography>
        </div>
      ) : null}
      {rewards ? (
        <div className={classes.attributesContainer}>
          <Typography variant="subtitle1" className={classes.subtitle}>
            REWARDS
          </Typography>
          <Typography variant="body1">{rewards}</Typography>
        </div>
      ) : null}
    </div>
  )
}
export default AttributesList
